// Kratki SEO uvodi za kategorije trgovskega središča kupish.si.
// Vsebina se prikaže pod imenom kategorije.

export const categoryIntros: Record<string, { lead: string; links?: Array<{ label: string; to: string }> }> = {
  "drogerija": {
    lead:
      "Izdelki za čiščenje doma in osebno nego iz ponudbe trgovin na kupish.si — čistila, krpe, pripomočki za čiščenje in antibakterijski izdelki. Vsak izdelek prodaja najemnik spletne trgovine, ki je naveden na strani izdelka.",
  },
  "nega-doma": {
    lead:
      "Vse za redno čiščenje in vzdrževanje doma: univerzalna in specialna čistila, mikrovlaknate krpe, ščetke in pripomočki, ki skrajšajo čas čiščenja.",
  },
  "cistila": {
    lead:
      "Čistila za kuhinjo, kopalnico, steklo in tla. Pri vsakem izdelku preverite namen uporabe, volumen in navodila proizvajalca.",
  },
  "krpe-za-ciscenje": {
    lead:
      "Mikrovlaknate in univerzalne krpe za suho ter mokro čiščenje. Trpežne krpe prenesejo več sto pranj in zmanjšajo porabo čistil.",
  },
  "pripomocki-za-ciscenje": {
    lead:
      "Ščetke, brisalci, nastavki in drobni pripomočki, ki olajšajo čiščenje težje dostopnih površin v gospodinjstvu.",
  },
  "antibakterijski-izdelki": {
    lead:
      "Izdelki za razkuževanje površin in rok. Pred uporabo preverite sestavo in navodila proizvajalca na embalaži.",
  },
  "osebna-nega": {
    lead:
      "Izdelki za vsakodnevno osebno nego iz ponudbe trgovin na kupish.si — od nege kože in las do praktičnih pripomočkov.",
  },
  "elektronika-avdio": {
    lead:
      "Zabavna elektronika in avdio oprema: slušalke, prenosni zvočniki, kamere in dodatki za telefone. Pri vsakem izdelku so navedene ključne specifikacije in prodajalec.",
  },
  "avdio-video": {
    lead:
      "Naprave za sliko in zvok — nadzorne in športne kamere, otroške varuške ter avdio oprema za dom.",
  },
  "zabavna-elektronika": {
    lead:
      "Slušalke, prenosni zvočniki in dodatki za telefonijo. Pred nakupom primerjajte način povezave, avtonomijo baterije in združljivost z napravo.",
  },
  "slusalke": {
    lead:
      "Brezžične in žične slušalke za glasbo, klice in šport. Ključni podatki pri izbiri so tip (naglavne, ušesne, TWS), Bluetooth različica in čas delovanja.",
  },
  "prenosni-zvocniki": {
    lead:
      "Prenosni Bluetooth zvočniki za dom, izlet ali delavnico. Pozorni bodite na moč, avtonomijo in odpornost proti vodi.",
  },
  "telefonija": {
    lead:
      "Dodatki za mobilne telefone — polnilci, kabli, držala in oprema za vsakodnevno uporabo.",
  },
  "otroske-varuske": {
    lead:
      "Avdio in video otroške varuške za nadzor nad otrokovo sobo. Preverite doseg, način prenosa slike in trajanje baterije.",
  },
  "nadzorne-kamere": {
    lead:
      "Kamere za nadzor doma, poslovnega prostora ali dvorišča. Pomembni podatki so ločljivost, nočno snemanje in način shranjevanja posnetkov.",
  },
  "avto-elektronika": {
    lead:
      "Elektronika za avto: avtomobilske kamere, prostoročni sistemi in FM oddajniki. Oprema, ki poveča varnost in udobje med vožnjo.",
  },
  "avto-kamere": {
    lead:
      "Avtomobilske kamere snemajo vožnjo in so v pomoč pri dokazovanju poteka prometne nesreče. Primerjajte ločljivost, vidni kot, nočno snemanje in način napajanja.",
  },
  "prostorocno-telefoniranje": {
    lead:
      "Prostoročni sistemi omogočajo telefoniranje med vožnjo brez držanja telefona v roki, kar zahteva tudi zakonodaja.",
  },
  "fm-radiji": {
    lead:
      "FM oddajniki predvajajo glasbo s telefona prek avtoradia. Priročna rešitev za starejša vozila brez povezave Bluetooth.",
  },
  "avtomobilska-oprema": {
    lead:
      "Praktična oprema za avto — polnilci in napajalniki, nosilci ter držala za telefon in navigacijo.",
  },
  "napajlniki-in-polnilci": {
    lead:
      "Avtomobilski polnilci in napajalniki za telefone, kamere in druge naprave. Preverite izhodno moč in tip priključka.",
  },
  "nosilci-in-drzala": {
    lead:
      "Nosilci in držala za telefon, navigacijo ali kamero. Izbirajte glede na način pritrditve: prezračevalna reža, vetrobransko steklo ali armaturna plošča.",
  },
  "dom-vrt": {
    lead:
      "Oprema za dom in vrt iz ponudbe trgovin na kupish.si — kuhinjski pripomočki, stojala, tekstil in izdelki za urejanje zunanjih površin.",
  },
  "kuhinja": {
    lead:
      "Pripomočki in oprema za kuhinjo — od posode in nožev do drobnih pomagal, ki poenostavijo pripravo hrane.",
  },
  "prti": {
    lead:
      "Namizni prti in tekstil za jedilno mizo. Pri izbiri upoštevajte dimenzije mize, material in način vzdrževanja.",
  },
  "vrt": {
    lead:
      "Izdelki za vrt, teraso in balkon — orodje, oprema in pripomočki za urejanje zelenih površin.",
  },
  "stojala": {
    lead:
      "Stojala in nosilci za dom — praktične rešitve za red in shranjevanje.",
  },
  "moda-dodatki": {
    lead:
      "Modni dodatki in nakit iz ponudbe trgovin na kupish.si. Pri vsakem izdelku sta navedena material in prodajalec.",
  },
  "nakit": {
    lead:
      "Nakit iz ponudbe trgovin na kupish.si — uhani, verižice, zapestnice in prstani. Pred nakupom preverite material, dimenzije in navodila za nego.",
  },
  "sport-prosti-cas": {
    lead:
      "Oprema za šport in prosti čas — od športnih kamer do pripomočkov za aktivnosti na prostem.",
  },
  "sportne-kamere": {
    lead:
      "Športne kamere za snemanje kolesarjenja, smučanja in drugih aktivnosti. Pomembni podatki so ločljivost, stabilizacija slike, vodoodpornost in nosilci v kompletu.",
  },
};

// Poglobljena SEO vsebina za kategorije z največ prikazi v Search Consolu.
// Prikaže se pod seznamom izdelkov; FAQ se hkrati izpiše kot FAQPage schema.
export type CategoryContent = {
  sections: Array<{ h: string; p: string[] }>;
  faq: Array<{ q: string; a: string }>;
};

export const categoryContent: Record<string, CategoryContent> = {
  "drogerija": {
    sections: [
      {
        h: "Kako izbrati čistila in pripomočke za dom",
        p: [
          "Osnovo gospodinjstva pokrijejo štirje izdelki: univerzalno čistilo za površine, čistilo za kopalnico z močnejšim delovanjem proti vodnemu kamnu, čistilo za steklo in sredstvo za tla. Vse ostalo je nadgradnja, ki se splača le, če imate specifičen material — na primer naravni kamen, parket ali indukcijsko ploščo.",
          "Pri vsakem čistilu preverite namen uporabe, volumen in navodila proizvajalca na embalaži. Koncentrati so na prvi pogled dražji, a ker jih redčite, je cena na uporabo pogosto nižja od cene že pripravljenih razpršil.",
        ],
      },
      {
        h: "Mikrovlaknate krpe: zakaj so pomembnejše od čistila",
        p: [
          "Kakovostna mikrovlaknata krpa pobere prah in maščobo tudi s samo vodo, zato zmanjša porabo čistil. Za različne prostore uporabljajte ločene krpe in jih barvno razdelite — ena za kuhinjo, ena za kopalnico, ena za steklo in ogledala.",
          "Krpe perite pri nižjih temperaturah in brez mehčalca, ker mehčalec zapre vlakna in krpa izgubi vpojnost. Tako trpežna krpa zdrži več sto pranj.",
        ],
      },
      {
        h: "Varna uporaba in shranjevanje",
        p: [
          "Čistil nikoli ne mešajte med seboj, še posebej ne izdelkov na osnovi klora s kislimi čistili. Med uporabo močnejših sredstev prezračujte prostor in uporabljajte rokavice, če to priporoča proizvajalec.",
          "Vse izdelke hranite v originalni embalaži, izven dosega otrok, in upoštevajte rok uporabe po odprtju, ki je naveden na etiketi.",
        ],
      },
    ],
    faq: [
      { q: "Kateri izdelki zadostujejo za osnovno čiščenje stanovanja?", a: "Univerzalno čistilo za površine, čistilo za kopalnico, čistilo za steklo, sredstvo za tla ter nekaj mikrovlaknatih krp in ščetka. To pokrije večino rednega čiščenja." },
      { q: "Kako pogosto zamenjam mikrovlaknato krpo?", a: "Ko vlakna postanejo groba, krpa pušča sledi ali ne vpija več vode. Ob pravilnem pranju brez mehčalca kakovostna krpa zdrži več sto pranj." },
      { q: "Ali smem mešati različna čistila?", a: "Ne. Mešanje čistil, zlasti izdelkov s klorom in kislih čistil, lahko sprosti nevarne pline. Uporabljajte eno sredstvo naenkrat in prostor prezračujte." },
      { q: "Kdo je prodajalec izdelkov v tej kategoriji?", a: "Vsak izdelek prodaja najemnik spletne trgovine na kupish.si. Prodajalec je naveden na strani izdelka, kjer najdete tudi njegove kontaktne podatke." },
    ],
  },
  "elektronika-avdio": {
    sections: [
      {
        h: "Slušalke: kaj primerjati pred nakupom",
        p: [
          "Najprej se odločite za obliko. Popolnoma brezžične (TWS) slušalke so najbolj priročne za pot in šport, ušesne z lokom bolje držijo med gibanjem, naglavne pa ponujajo daljšo avtonomijo in običajno boljše dušenje hrupa.",
          "Nato preverite tri podatke: različico Bluetootha, čas delovanja z enim polnjenjem in skupni čas s polnilno škatlico ter podporo za mikrofon in klice. Če slušalke uporabljate pri športu, je pomembna tudi oznaka odpornosti proti vodi in znoju.",
        ],
      },
      {
        h: "Prenosni zvočniki za dom in pot",
        p: [
          "Pri prenosnih zvočnikih moč sama po sebi ne pove veliko. Bolj kot vatna moč sta pomembna velikost membrane in avtonomija baterije — večji zvočnik pri isti moči zveni polneje, manjši pa je bolj priročen za nošnjo.",
          "Za uporabo na terasi, ob bazenu ali na izletu izberite model z odpornostjo proti vodi in pršcu. Preverite tudi način polnjenja: sodobni modeli uporabljajo USB-C, kar poenostavi opremo na poti.",
        ],
      },
      {
        h: "Kamere za nadzor in varstvo",
        p: [
          "Nadzorne kamere primerjajte po ločljivosti, vidnem kotu, nočnem snemanju in načinu shranjevanja posnetkov. Snemanje na pomnilniško kartico deluje brez naročnine, oblačna shramba pa je uporabna, če želite dostop do posnetkov tudi ob kraji naprave.",
          "Otroške varuške izbirajte glede na doseg signala, kakovost prenosa in trajanje baterije. Modeli s sliko olajšajo nadzor, avdio varuške pa so cenejše in porabijo manj energije.",
        ],
      },
    ],
    faq: [
      { q: "Katere slušalke so najprimernejše za šport?", a: "Lahke ušesne ali TWS slušalke z varnim prileganjem in oznako odpornosti proti vodi ter znoju. Pomembna je tudi zanesljiva povezava s telefonom med gibanjem." },
      { q: "Koliko časa delujejo brezžične slušalke?", a: "Odvisno od modela. Podatek o avtonomiji je naveden pri vsakem izdelku, običajno ločeno za slušalke in za skupni čas s polnilno škatlico." },
      { q: "Ali prenosni zvočnik prenese uporabo na prostem?", a: "Le, če ima proizvajalec navedeno odpornost proti vodi ali pršcu. Ta podatek je zapisan v specifikacijah izdelka." },
      { q: "Kaj potrebujem za snemanje z nadzorno kamero?", a: "Napajanje, način shranjevanja posnetkov (pomnilniška kartica ali oblak) in pri brezžičnih modelih stabilno omrežje Wi-Fi. Podprte možnosti so navedene pri izdelku." },
    ],
  },
  "avto-elektronika": {
    sections: [
      {
        h: "Avtomobilska kamera: na kaj biti pozoren",
        p: [
          "Avtomobilska kamera neprekinjeno snema vožnjo in posnetke shranjuje v zanki, tako da nove datoteke prepišejo najstarejše. Ob močnejšem tresljaju ali trku senzor zaklene trenutni posnetek, da se ne prepiše.",
          "Pri izbiri primerjajte ločljivost snemanja, vidni kot, kakovost nočnega posnetka in način napajanja. Kamera z ločljivostjo Full HD in dobrim nočnim načinom je v praksi uporabnejša od slabo osvetljenega posnetka v višji ločljivosti.",
        ],
      },
      {
        h: "Prostoročno telefoniranje in FM oddajniki",
        p: [
          "Uporaba telefona med vožnjo brez prostoročnega sistema je v Sloveniji prekršek. Prostoročni komplet ali držalo s povezavo Bluetooth je zato osnovna oprema vsakega voznika.",
          "FM oddajnik je rešitev za starejša vozila brez povezave Bluetooth: glasbo s telefona pošlje na prosto FM frekvenco avtoradia. Za čist zvok izberite frekvenco, ki je v vaši okolici ne zaseda nobena radijska postaja.",
        ],
      },
      {
        h: "Montaža in vzdrževanje",
        p: [
          "Kamero namestite tako, da ne zakriva voznikovega vidnega polja — običajno za vzvratnim ogledalom. Kabel speljite ob robu vetrobranskega stekla, da ne moti upravljanja vozila.",
          "Pomnilniško kartico občasno formatirajte v napravi, saj neprekinjeno snemanje v zanki obremenjuje pomnilnik. Uporabljajte kartice, ki jih proizvajalec navaja kot združljive.",
        ],
      },
    ],
    faq: [
      { q: "Ali je snemanje z avtomobilsko kamero v Sloveniji dovoljeno?", a: "Snemanje za lastno evidenco vožnje je razširjena praksa, posnetke pa je treba obravnavati skladno s predpisi o varstvu osebnih podatkov in jih ne objavljati brez podlage." },
      { q: "Kakšno pomnilniško kartico potrebuje avto-kamera?", a: "Uporabite kartico razreda in kapacitete, ki ju navaja proizvajalec naprave. Kartice, namenjene neprekinjenemu snemanju, prenesejo več ciklov pisanja." },
      { q: "Zakaj FM oddajnik šumi?", a: "Najpogosteje zato, ker je izbrana frekvenca deloma zasedena. Poiščite popolnoma prosto frekvenco in preverite, da je oddajnik trdno vstavljen v vtičnico." },
      { q: "Ali smem med vožnjo uporabljati telefon v držalu?", a: "Telefon mora biti nameščen v držalu, klici pa opravljeni prostoročno. Ročno upravljanje telefona med vožnjo ni dovoljeno." },
    ],
  },
  "dom-vrt": {
    sections: [
      {
        h: "Oprema za kuhinjo, ki se dejansko uporablja",
        p: [
          "Pri kuhinjskih pripomočkih se izplača manj kosov boljše kakovosti. Osnovo pokrijejo dober nož, deska, posoda za pripravo in nekaj pomagal, ki jih uporabljate vsak teden — vse ostalo pogosto obleži v predalu.",
          "Pri vsakem izdelku preverite material in navodila za vzdrževanje, zlasti ali je primeren za pomivalni stroj in za katere vrste kuhališč je namenjen.",
        ],
      },
      {
        h: "Tekstil za jedilno mizo",
        p: [
          "Prt izbirajte glede na dimenzije mize: na vsaki strani naj sega vsaj 20 centimetrov čez rob, pri svečanem pogrinjku tudi več. Material določa videz in vzdrževanje — bombaž je prijeten in pralen, mešanice se manj mečkajo.",
          "Pri izdelkih preverite navedene mere in navodila za pranje, saj se nekateri materiali po prvem pranju nekoliko skrčijo.",
        ],
      },
      {
        h: "Vrt, terasa in shranjevanje",
        p: [
          "Za urejanje vrta in terase so najbolj uporabni izdelki, ki prenesejo vremenske vplive. Preverite material in ali je izdelek namenjen zunanji uporabi skozi vse leto ali le v topli polovici leta.",
          "Stojala in nosilci rešujejo največjo težavo majhnih stanovanj — pomanjkanje prostora. Pred nakupom izmerite mesto namestitve in preverite nosilnost, ki jo navaja proizvajalec.",
        ],
      },
    ],
    faq: [
      { q: "Kako izberem pravo velikost prta?", a: "Izmerite dolžino in širino mize ter obema meram prištejte vsaj 40 centimetrov, da prt na vsaki strani sega približno 20 centimetrov čez rob." },
      { q: "So kuhinjski pripomočki primerni za pomivalni stroj?", a: "Podatek je naveden pri posameznem izdelku. Pri lesenih in nekaterih premazanih izdelkih proizvajalci priporočajo ročno pomivanje." },
      { q: "Kateri izdelki so primerni za zunanjo uporabo?", a: "Tisti, pri katerih je zunanja uporaba izrecno navedena. Materiali za zunanjo uporabo prenesejo vlago in temperaturne razlike." },
      { q: "Kako preverim nosilnost stojala ali nosilca?", a: "Nosilnost navaja proizvajalec v specifikacijah izdelka. Upoštevajte tudi vrsto stene ali površine, na katero izdelek pritrjujete." },
    ],
  },
};
